var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"collapse-on-scroll":"","app":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleDrawer}}),_c('v-spacer'),_c('UserInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }